var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#F7F8FA"},attrs:{"id":"app"}},[_c('Notification'),(!_vm.isPageReady)?_c('b-progress',{staticClass:"mt-4",attrs:{"type":"is-primary"}}):_vm._e(),(_vm.isPageReady)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }